// https://vuex.vuejs.org/en/modules.html

const requireModule = require.context('.', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return

  // Replace ./ and .js
  const path = fileName.replace(/(\.\/|\.js)/g, '')
  const paths = path.split('/')
  let moduleName, imported

  if (paths.length === 2) {
    moduleName = `${paths[0]}`
    imported = paths[1]
  } else if (paths.length === 4) {
    moduleName = `${paths[0]}/${paths[2]}`
    imported = paths[3]
  }

  if (!modules[moduleName]) {
    modules[moduleName] = {
      namespaced: true
    }
  }

  modules[moduleName][imported] = requireModule(fileName).default
})

export default modules
